/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { JobSequenceAnalyticsDay } from './jobSequenceAnalyticsDay';
import type { JobSequenceAnalyticsOverview } from './jobSequenceAnalyticsOverview';

/**
 * Read shape for ``GET /api/jobs/{job_id}/sequences/analytics``.
 */
export interface JobSequenceAnalyticsResponse {
  /**
     * @minimum 1
     * @maximum 365
     */
  days: number;
  timezone: string;
  /** @maxItems 365 */
  series: JobSequenceAnalyticsDay[];
  overview: JobSequenceAnalyticsOverview;
}
